import * as Yup from "yup";

export const validationSchema = (infoData, requiredMessage) =>
  Yup.object({
    phone: Yup.string()
      .matches(/^(009665|\+9665|05)\d{8}$/, infoData.phone?.phoneFormat)
      .required(requiredMessage),
    new_password: Yup.string()
      .min(8, infoData.newPassword?.passwordFormat)
      .required(requiredMessage),
    new_password_confirmation: Yup.string()
      .oneOf(
        [Yup.ref("new_password"), null],
        infoData.newPasswordConfirm?.passwordMatch
      )
      .required(requiredMessage),
  });
